<template>
    <div class="card text-center card-hover">
        <div class="card-body">
            <h5 class="card-title">{{ data.title }}</h5>
            <p class="card-text">{{ data.description }}</p>

            <div class="flex-grow-1 d-flex flex-column justify-content-end">
                <page-preloader
                    v-if="data.status === 'loading'"
                    small
                    min-height="6rem"
                    :is-loading="true"
                />
                <div v-else class="card-number" :class="data.class">
                    {{ data.value }}
                </div>
                <button
                    class="card-btn btn btn-outline-custom"
                    :class="{ invisible: data.isBtnHidden }"
                    @click="doAction"
                >
                    Sprawdź
                </button>
            </div>
            <lottery-info-container
                v-if="isLotteryUser"
                class="pt-3"
                font-tiny
            />
        </div>
    </div>
</template>

<script>
import LotteryInfoContainer from '@/components/lottery/LotteryInfoContainer.vue'

export default {
    name: 'DashboardCard',
    components: { LotteryInfoContainer },
    props: {
        data: {
            type: Object,
            required: true
        }
    },
    computed: {
        isLotteryUser() {
            return this.$store.getters.isLotteryUser
        }
    },
    methods: {
        doAction() {
            if (this.isLotteryUser) {
                this.$store.dispatch('onLotteryUserNoPermission')
            } else if (this.data.moduleName) {
                this.$store
                    .dispatch('clearFilters', this.data.moduleName)
                    .then(() => {
                        if (this.data.setFilter) {
                            this.$store
                                .dispatch('setFilter', {
                                    filter: this.data.setFilter.filter,
                                    value: this.data.setFilter.value,
                                    moduleName: this.data.moduleName
                                })
                                .then(() => {
                                    if (this.data.action) {
                                        this.$router.push(this.data.action)
                                        this.$store.dispatch(this.data.action)
                                    }
                                    if (this.data.function) {
                                        this.$router.push(this.data.function)
                                    }
                                })
                        } else {
                            if (this.data.action) {
                                this.$store.dispatch(this.data.action)
                            }
                            if (this.data.function) {
                                this.$router.push(this.data.function)
                            }
                        }
                    })
            } else {
                if (this.data.action) {
                    this.$store.dispatch(this.data.action)
                }
                if (this.data.function) {
                    this.$router.push(this.data.function)
                }
            }
        }
    }
}
</script>
